import React from 'react'
import PhotoModal from './PhotoCarousel/PhotoModal'
import CarouselControls from './PhotoCarousel/CarouselControls'
import PhotoGrid from './PhotoCarousel/PhotoGrid'
import { usePhotoCarousel } from '../hooks/usePhotoCarousel'
import { useCarouselAnimation } from '../hooks/useCarouselAnimation'
import { useDragControls } from '../hooks/useDragControls'
import { useThemeDetection } from '../hooks/useThemeDetection'

const PhotoCarousel = () => {
  const { photos, uniquePhotos, loading, error, selectedPhoto, handlePhotoClick, closeModal } = usePhotoCarousel()
  const { scrollRef, isAutoPlaying, toggleAutoPlay, scrollToDirection, pauseAnimation, resumeAnimation } = useCarouselAnimation(photos)
  const { isDragging, handleMouseDown, handleMouseMove, handleMouseUp } = useDragControls(scrollRef, pauseAnimation, resumeAnimation)
  const { isClearTheme } = useThemeDetection()

  if (loading) {
    return <CarouselLoading />
  }

  // Hide carousel completely if no photos
  if (error || photos.length === 0) {
    return null
  }

  return (
    <div className="w-full">
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 overflow-hidden relative">
        <CarouselControls
          isAutoPlaying={isAutoPlaying}
          onScrollLeft={() => scrollToDirection('left')}
          onScrollRight={() => scrollToDirection('right')}
          onToggleAutoPlay={toggleAutoPlay}
        />

        <PhotoGrid
          scrollRef={scrollRef}
          photos={photos}
          isDragging={isDragging}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onPhotoClick={(photo) => handlePhotoClick(photo, isDragging)}
        />

        <CarouselInfo uniquePhotos={uniquePhotos} isAutoPlaying={isAutoPlaying} />
      </div>

      <PhotoModal
        photo={selectedPhoto}
        isClearTheme={isClearTheme}
        onClose={closeModal}
      />
    </div>
  )
}

const CarouselLoading = () => (
  <div className="w-full">
    <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-6">
      <div className="animate-pulse">
        <div className="bg-white/20 h-48 rounded-xl mb-4"></div>
        <div className="h-6 bg-white/20 rounded mb-2"></div>
        <div className="h-4 bg-white/20 rounded w-3/4"></div>
      </div>
    </div>
  </div>
)

const CarouselInfo = ({ uniquePhotos, isAutoPlaying }) => (
  <div className="p-4 bg-white/5 border-t border-white/10">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-white text-sm font-medium">
          📸 Your Event Memories
        </p>
        <p className="text-gray-400 text-xs">
          {uniquePhotos?.length || 0} photos • Use controls to navigate • {isAutoPlaying ? 'Auto-playing' : 'Paused'}
        </p>
      </div>
    </div>
  </div>
)

export default PhotoCarousel